import styled from 'styled-components'

export const ColumnText = styled.div`
display: flex;
flex-direction: column;
margin-right:2rem;

h4{
    font-size: 13px;
}

span{
font-weight: 700;
font-size: 0.875rem;
}
`

export const PreViewParticipante = styled.div`
display: flex;
justify-content: space-between;
background: var(--c2);
font-weight: 600;
border-radius: 0.25rem;
height: 6rem;
`

export const RadiusLeft = styled.div`
 background:#${props => props.theme};
 width: .75rem;
 height: 100%;
 border-top-left-radius:0.25rem ;
 border-bottom-left-radius:0.25rem ;
 margin-right: .75rem;
`

export const BackgroundCollapse = styled.div<{active: boolean}>`
background: var(--c1);
border-radius: 0.25rem;
border: 1px solid var(--c4);
box-shadow: var(--SombraBtns);
overflow-y: hidden;
max-height: 6rem;

${({ active }) => active && `
     transition: max-height 7.2s;
     max-height: 800rem;
`}
`
